
(function () {
  'use strict';

  
  
  
  
  function initAriaAccordions() {
    document.querySelectorAll('.product-accordion').forEach(function (b) {
      if (!b.getAttribute('type')) b.setAttribute('type', 'button');
    });

    var pendingBtn = null;
    var beforeTop = 0;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-accordion');
      if (!btn) { pendingBtn = null; return; }
      pendingBtn = btn;
      beforeTop = btn.getBoundingClientRect().top;
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-accordion');
      if (!btn || btn !== pendingBtn) return;
      pendingBtn = null;

      var content = btn.nextElementSibling;
      var isNowOpen = !!(content && content.style.maxHeight);
      if (btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', isNowOpen ? 'true' : 'false');
      }

      var htmlEl = document.documentElement;
      var startTs = null;
      var pin = function (ts) {
        if (startTs === null) startTs = ts;
        var d = btn.getBoundingClientRect().top - beforeTop;
        if (d < -0.5 || d > 0.5) {
          var prevSB = htmlEl.style.scrollBehavior;
          htmlEl.style.scrollBehavior = 'auto';
          window.scrollTo(0, window.pageYOffset + d);
          htmlEl.style.scrollBehavior = prevSB;
        }
        if (ts - startTs < 600) {
          requestAnimationFrame(pin);
        }
      };
      requestAnimationFrame(pin);
    });
  }

  
  
  
  var FOCUSABLE_SELECTORS = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  var _trapContainer = null;
  var _lastFocused   = null;

  function getFocusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE_SELECTORS),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function trapFocus(container) {
    _trapContainer = container;
    var focusables = getFocusables(container);
    if (focusables.length) focusables[0].focus();
    container.addEventListener('keydown', handleTrapKey);
  }

  function handleTrapKey(e) {
    if (e.key !== 'Tab' || !_trapContainer) return;
    var focusables = getFocusables(_trapContainer);
    if (!focusables.length) return;
    var first = focusables[0];
    var last  = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }

  function releaseTrap() {
    if (_trapContainer) {
      _trapContainer.removeEventListener('keydown', handleTrapKey);
      _trapContainer = null;
    }
    if (_lastFocused && typeof _lastFocused.focus === 'function') {
      try { _lastFocused.focus(); } catch (e) {}
      _lastFocused = null;
    }
  }

  
  
  
  var MODAL_MAP = {
    'fade-search':     '.modal-search-content',
    'slide-cart':      '.modal-cart',
    'fade-review':     '.modal-review',
    'fade-news':       '.modal-news',
    'fade-sizechart':  '.modal-sizechart',
    'fade-sizechart2': '.modal-sizechart2',
    'fade-sizechart3': '.modal-sizechart3',
    'fade-restock':    '.modal-restock',
    'fade-video':      '.modal-video',
    'slide-filters':   '.modal-filters',
    'fade-promo':      '.modal-promo',
    'fade-exit':       '.modal-exit',
    'fade-subscribe':  '.modal-subscribe',
    'fade-upsell':     '.modal-upsell',
    'fade-restricted': '.modal-restricted',
    'fade-zoom':       '.modal-zoom'
  };

  
  
  
  
  function initModalObserver() {
    var body = document.body;
    var prevClasses = new Set(body.className.split(' ').filter(Boolean));

    var observer = new MutationObserver(function () {
      var currentClasses = new Set(body.className.split(' ').filter(Boolean));

      
      currentClasses.forEach(function (cls) {
        if (!prevClasses.has(cls) && MODAL_MAP[cls]) {
          _lastFocused = document.activeElement;
          var selector  = MODAL_MAP[cls];
          
          setTimeout(function () {
            var container = document.querySelector(selector);
            if (container) trapFocus(container);
          }, 60);
        }
      });

      
      prevClasses.forEach(function (cls) {
        if (!currentClasses.has(cls) && MODAL_MAP[cls]) {
          releaseTrap();
        }
      });

      
      var burger = document.getElementById('burger');
      if (burger) {
        burger.setAttribute('aria-expanded', currentClasses.has('slide-nav') ? 'true' : 'false');
      }

      
      var filtersBtn = document.getElementById('filters-icon');
      if (filtersBtn) {
        filtersBtn.setAttribute('aria-expanded', currentClasses.has('slide-filters') ? 'true' : 'false');
      }

      prevClasses = currentClasses;
    });

    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  
  
  
  function initObSeoKeyboard() {
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('ob-seo')) {
        if (e.__idmClavier) return;
        e.__idmClavier = true;
        e.preventDefault();
        e.target.click();
      }
    });
  }

  
  
  
  function initSlideshowDotKeyboard() {
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('slideshow__dot')) {
        e.preventDefault();
        e.target.click();
      }
    });
  }

  
  
  
  function initSlideshowDotAriaSync() {
    document.querySelectorAll('.slideshow').forEach(function (slideshow) {
      var dots = slideshow.querySelectorAll('.slideshow__dot');
      if (!dots.length) return;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var dot = mutation.target;
          if (!dot.classList.contains('slideshow__dot')) return;
          var isActive = dot.classList.contains('slideshow__dot__active');
          if (isActive) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
        });
      });

      dots.forEach(function (dot) {
        observer.observe(dot, { attributes: true, attributeFilter: ['class'] });
      });
    });
  }

  
  
  
  
  function initRoleButtonKeyboard() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var target = e.target;
      
      if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT') return;
      if (target.matches && target.matches('.ob-seo, [data-ob-direction]')) return;
      if (target.getAttribute('role') === 'button' || target.getAttribute('role') === 'link') {
        e.preventDefault();
        target.click();
      }
    });

    
    document.addEventListener('click', function (e) {
      var target = e.target.closest('[role="button"][aria-controls]');
      if (!target) return;
      var expanded = target.getAttribute('aria-expanded') === 'true';
      target.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  }

  
  
  
  function init() {
    initAriaAccordions();
    initModalObserver();
    initObSeoKeyboard();
    initSlideshowDotKeyboard();
    initSlideshowDotAriaSync();
    initRoleButtonKeyboard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  if (window.__IDM_OBSEO_CLAVIER__) return;
  window.__IDM_OBSEO_CLAVIER__ = true;
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.matches || !t.matches('.ob-seo[role="link"]')) return;
    if (e.__idmClavier) return;
    e.__idmClavier = true;
    e.preventDefault();
    t.click();
  });
})();
